import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { createUrl, request } from 'app/utils';
import { Flex, Loading, Page, Section } from 'components';

import { useEducational, EducationalInstitutionActivationBatchType, EducationalInstitutionStudentDetailResponse } from 'features/educational';
import { RegisterGuardian, RegisterTeacher, RegisterStudent } from 'features/educational';
import { useAuth } from 'features/auth';
import { useSchool } from 'features/school';

const Register = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const isLoggedUser = searchParams.get('logged');

  const { isLogged } = useAuth();
  const { schoolUuid } = useSchool();

  const [loading, setLoading] = useState(true);

  const { activateCode, activationCode, setStudentDetail } = useEducational();

  useEffect(() => {
    if (activationCode) {
      setLoading(false);
    } else {
      navigate(createUrl('educational/activate/code'));
    }
  }, [activationCode]);

  const getStudentDetails = useCallback(async () => {
    await request<EducationalInstitutionStudentDetailResponse>({
      url: `/api/v1/School/EducationalInstitution/StudentDetails`,
      params: {
        schoolUuid,
        activationCode,
      },
    }).then(({ data }) => {
      setStudentDetail(data);
    });
  }, [isLoggedUser, isLogged, schoolUuid, activationCode]);

  useEffect(() => {
    if (isLoggedUser && isLogged && !loading) getStudentDetails();
  }, [isLoggedUser, isLogged, loading, schoolUuid, activationCode]);

  if (loading) return <Loading />;

  return (
    <Page title="MELVER nas Escolas">
      <Flex justifyContent="flex-start" flexDirection="column" minHeight="100vh" bg="primary_10">
        <Flex flexGrow={0} bg="white" borderWidth={1} borderStyle="solid" borderColor="gray_100" justifyContent="center" p={3}>
          <img src="/images/melver-nas-escolas/logo.png" width={270} alt="MELVER nas Escolas" />
        </Flex>

        <Section flexGrow={0} flexDirection="column" maxWidth={{ m: '80%', t: 580, d: 720 }} py={6}>
          {activateCode?.type === EducationalInstitutionActivationBatchType.Student && <RegisterStudent />}
          {activateCode?.type === EducationalInstitutionActivationBatchType.Guardian && <RegisterGuardian />}
          {activateCode?.type === EducationalInstitutionActivationBatchType.Teacher && <RegisterTeacher />}
        </Section>
      </Flex>
    </Page>
  );
};

export default Register;
